import { Stack } from '@mui/material';
import { FC, ReactNode, useState } from 'react';
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Button, CopyButton, Typography } from 'melp-design/components';

interface Props {
  label: string;
  value?: ReactNode;
  fallback?: string;
  maxLines?: number;
  copyable?: {
    value: string;
  };
  hidable?: {
    value: string;
  };
}

export const LabeledValue: FC<Props> = ({
  label,
  value,
  fallback = '-',
  maxLines,
  copyable,
  hidable,
}) => {
  const { t } = useTranslation();
  const [isRevealed, setIsRevealed] = useState(false);

  return (
    <Stack gap={0.5}>
      <Typography variant="p1" color="textSecondary">
        {label}
      </Typography>
      <Stack direction="row" alignItems="center" gap={2} minHeight={30}>
        <Typography
          variant="p1"
          color="textPrimary"
          component="span"
          maxLines={maxLines}
        >
          {isRevealed && hidable ? hidable.value : value ?? fallback}
        </Typography>

        <Stack direction="row" alignItems="center" gap={0.5}>
          {hidable ? (
            <Button
              icon={isRevealed ? VisibilityOffOutlined : VisibilityOutlined}
              variant="neutral-fill"
              type="button"
              size="sm"
              onClick={() => setIsRevealed((current) => !current)}
              tooltip={isRevealed ? t('common.hide') : t('common.unhide')}
            />
          ) : null}
          {copyable ? <CopyButton value={copyable.value} size="sm" /> : null}
        </Stack>
      </Stack>
    </Stack>
  );
};
